import { CartBase } from "./cart-base";
export class StatelessCart extends CartBase {
    patch = { addDiscounts: [], addCoupons: [], addItemsCoupons: [], markedItems: [], discountAmount: 0 };
    constructor(snapshot) {
        // deep clone so the sandbox doesn’t mutate the app’s real cart
        super(structuredClone(snapshot));
    }
    _addDiscountAmount(discountAmount) {
        this.patch.discountAmount += discountAmount;
        this._cartData.discount += discountAmount;
    }
    // Record deltas + update sandbox state
    _addDiscountsToItems(discountItems) {
        for (const di of discountItems) {
            this.patch.addDiscounts.push(di);
            const item = this._cartData.items[di.itemArrayIndex];
            item.beforeTaxDiscount += di.beforeTaxDiscount;
            item.afterTaxDiscount += di.afterTaxDiscount;
        }
    }
    _addCouponToCart(coupon) {
        const nextKey = (this._cartData.coupons.length
            ? Math.max(...this._cartData.coupons.map(c => c.couponKey))
            : 0) + 1;
        this.patch.addCoupons.push({ couponId: coupon.couponId, couponKey: nextKey });
        const newCoupon = { couponId: coupon.couponId, couponKey: nextKey, isReward: coupon.isReward, amount: this._cartData.discount };
        this._cartData.coupons.push(newCoupon);
        return nextKey;
    }
    _addCouponToItemsCoupons(couponKey, discountItems) {
        for (const di of discountItems) {
            this.patch.addItemsCoupons.push({
                couponKey,
                itemKey: di.itemKey,
                itemRecId: di.itemRecId,
                beforeTaxDiscount: di.beforeTaxDiscount,
                afterTaxDiscount: di.afterTaxDiscount,
            });
            this._cartData.itemsCoupons.push({
                couponKey,
                itemKey: di.itemKey,
                itemRecId: di.itemRecId,
                beforeTaxDiscount: di.beforeTaxDiscount,
                afterTaxDiscount: di.afterTaxDiscount,
                halfIndex: di.halfIndex,
            });
        }
    }
    _clearMarkedItems() {
        for (const item of this._cartData.items)
            item.discountedMarkedQuantity = 0;
    }
    _useMarkedItems() {
        for (const item of this._cartData.items) {
            this.patch.markedItems.push({
                itemKey: item.itemKey,
                halfIndex: item.halfIndex,
                markedQty: item.discountedQuantity + item.discountedMarkedQuantity
            });
            item.discountedQuantity = item.discountedMarkedQuantity;
            item.discountedMarkedQuantity = 0;
        }
    }
}
//# sourceMappingURL=cart-stateless.js.map